import { contextApi } from "../context/contextApi";
import { useContext, useEffect } from "react";

function Success() {
    const context = useContext(contextApi)
    useEffect(() => {
        context.setLogin(false)
    }, []);
    return (
        <div className="flex flex-col h-full w-full ">
            <div className="m-auto">
                <img src="/images/success.svg" />
                <p className="my-5">تراکنش شما با موفقیت انجام شد</p>
            </div>
        </div>
    );
}

export default Success;